import { gql } from '@apollo/client';

const SAVE_USER_SETTING_MUTATION = gql`
  mutation UpdatePliUserSetting($data: PliUserSettingInput!) {
    updatePliUserSetting(data: $data) {
      setting
      value
    }
  }
`;

export default SAVE_USER_SETTING_MUTATION;
